'use client';
import LogRocket from 'logrocket';
import React, { useEffect } from 'react';
import { useGetUserQuery } from '../api';

export const LogRocketProvider = ({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) => {
  const { data: user } = useGetUserQuery();
  try {
    LogRocket.init(process.env.NEXT_PUBLIC_LOGROCKET_APP_ID || '', {
      rootHostname: 'saas.joinscaleup.com',
    });

    useEffect(() => {
      if (!user) return;
      LogRocket.identify(user.userEmail, {
        name: `${user.firstName} ${user.lastName}`,
        email: user.userEmail,
      });
    }, [user]);
  } catch (error) {
    console.error('LogRocket initialization failed', error);
  }
  return children;
};
